import { render, staticRenderFns } from "./DetailsPerf.vue?vue&type=template&id=49c61795&scoped=true"
import script from "./DetailsPerf.vue?vue&type=script&lang=js"
export * from "./DetailsPerf.vue?vue&type=script&lang=js"
import style0 from "./DetailsPerf.vue?vue&type=style&index=0&id=49c61795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c61795",
  null
  
)

export default component.exports